<template>
  <el-dialog
          :title="title"
          width="600"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)">
    <el-carousel height="450px" :autoplay="false">
      <el-carousel-item v-for="item in privaImgObj" :key="item">
        <div class="banner-list">
          <img :src="item" alt="">
        </div>
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>
<script>
  export default {
    name: "previewImgDialog",
    props: ["visible", "title", "privaImgObj"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible
      };
    }
  };
</script>

